import { Box, Divider } from '@mui/material';
import React from 'react';
import { SearchField } from './FormFields/SearchField';
import { CustomIconButton } from '../utils/CustomIcon';
import SearchIcon from '@mui/icons-material/Search';
import { BOX_SHADOW, DividerBorder } from '../constants';

const searchFieldStyles = {
    '&:hover': { backgroundColor: '#EBEBEB' },
    py: { xs: 2, md: 1.5 },
    px: {xs:0.5,sm:2},
    borderRadius: '50px',
    display: 'flex',
    alignItems: 'center',
    transition: 'background-color 0.3s ease-in-out',
};

const SearchBar = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
                sx={{
                    width: { xs: '100%', md: '70%' },
                    border: DividerBorder,
                    boxShadow: BOX_SHADOW,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: '50px',
                    gap: { xs: 0, lg: 1 },
                    // p: { xs: 1, md: 2 },
                }}
            >
                {[{ label: 'Where', placeholder: 'Search apartments' },
                { label: 'City', placeholder: 'Search city' },
                { label: 'Course Name', placeholder: 'Search course', hasButton: true }].map((field, index, arr) => (
                    <React.Fragment key={field.label}>
                        <Box sx={searchFieldStyles}>
                            <SearchField label={field.label} placeholder={field.placeholder} />
                            {field.hasButton && (
                                <CustomIconButton
                                    icon={<SearchIcon sx={{ color: 'primary.main', fontSize: '20px' }} />}

                                    bgcolor={'red.main'}
                                />
                            )}
                        </Box>
                        {index < arr.length - 1 && <Divider orientation="vertical" flexItem sx={{ border: DividerBorder }} />}
                    </React.Fragment>
                ))}
            </Box>
        </Box>
    );
};

export default SearchBar;
